import { IconButton } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import { theme } from 'config'
import { THEMES_NAME } from 'config/theme.config'

import { Icon } from '../../../../Icon'
import { Dropdown } from '../../../../Dropdown'

import * as S from './styles'

type CertificationDropdownProps = {
  setDeleteCertification: () => void
  handleEdit: () => void
  openModal: () => void
}

export const CertificationDropdown = ({
  setDeleteCertification,
  handleEdit,
  openModal
}: CertificationDropdownProps) => {
  const { t } = useTranslation()

  const handleDelete = () => {
    setDeleteCertification()
  }

  return (
    <S.Wrapper>
      <Dropdown
        title={
          <IconButton
            id="action"
            color="inherit"
            aria-label="open drawer"
            onClick={() => {}}
            size="medium"
            edge="start"
          >
            <Icon
              icon={
                theme.appTheme === THEMES_NAME.swift
                  ? 'itens-interface-actions-swift'
                  : 'itens-interface-actions'
              }
              width={12}
              height={12}
              aria-label="action"
            />
          </IconButton>
        }
      >
        <S.Nav>
          <S.Link onClick={handleEdit}>
            <Icon icon="dropdown-edit" height={16} width={16} />
            <span>{t('common:edit')}</span>
          </S.Link>
          <S.Link onClick={handleDelete}>
            <Icon icon="dropdown-delete" height={16} width={16} />
            <span>{t('common:delete')}</span>
          </S.Link>
          <S.Link onClick={openModal}>
            <Icon icon="dropdown-visible-file" height={16} width={16} />
            <span>{t('tables:view')}</span>
          </S.Link>
        </S.Nav>
      </Dropdown>
    </S.Wrapper>
  )
}
